import { FC } from 'react'
import { BooleanInput, FileField, FileInput, required, SelectInput, TextInput, useRecordContext } from 'react-admin'
import { Samenwerking } from '../../../types/apiRequests'
import { KENMERK_SYSTEEM } from '../../../utils/getCaseUrl'
import { isZakenOrganization, useOrganizationSettings } from '../../../utils/useOrganizationSettings'

const CreateDocumentForm: FC = () => {
  const record = useRecordContext<Samenwerking>()
  const orgSettings = useOrganizationSettings()
  const isZaken = isZakenOrganization(orgSettings)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const canSyncToZaken = isZaken && (record?.kenmerkSysteem === KENMERK_SYSTEEM.XXLLNC_ZAKEN || !!record?.zaak_nummer)

  return (
    <>
      <TextInput
        source="formValues.documentOmschrijving"
        label="data.documentDescription"
      />
      <SelectInput
        source="formValues.vertrouwelijkheidsAanduiding"
        label="data.confidentiality"
        choices={[
          { id: 'RV', name: 'resources.collaborations.confidentiality.RV' },
          { id: 'SV', name: 'resources.collaborations.confidentiality.SV' },
        ]}
        defaultValue="RV"
        validate={required()}
      />
      <SelectInput
        source="formValues.taal"
        label="data.language"
        choices={[
          { id: 'nl', name: 'Nederlands (nl)' },
        ]}
        defaultValue="nl"
        validate={required()}
      />
      <FileInput
        source="formValues.file"
        label="data.file"
        multiple={false}
        accept={{
          'application/pdf': ['.pdf'],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
          'application/msword': ['.doc'],
          'application/vnd.ms-excel': ['.xls'],
          'image/jpeg': ['.jpg', '.jpeg'],
          'image/png': ['.png'],
          'image/tiff': ['.tif', '.tiff'],
          'text/plain': ['.txt'],
          'text/csv': ['.csv'],
          'text/xml': ['.xml'],
          'application/xml': ['.xml'],
          'application/zip': ['.zip'],
          'message/rfc822': ['.eml'],
        }}
        validate={required()}
      >
        <FileField source="src" title="title" />
      </FileInput>
      {canSyncToZaken && (
        <BooleanInput
          source="formValues.syncToZaken"
          label="data.syncToZaken"
          defaultValue={true}
        />
      )}
    </>
  )
}

export default CreateDocumentForm
